import axios from "axios";
import { IP } from "./config";

// 查询
export async function selectCardCouponGoods(data) {
  var resp = await axios.post(`${IP}/cardCouponGoods/select`, { ...data });
  return resp.data;
}

// 新增
export async function addCardCouponGoods(data) {
  var resp = await axios.post(`${IP}/cardCouponGoods/add`, {
    ...data,
  });
  return resp.data;
}

// 修改
export async function updateCardCouponGoods(data) {
  var resp = await axios.post(`${IP}/cardCouponGoods/update`, {
    ...data,
  });
  return resp.data;
}



// 删除
export async function deleteCardCouponGoods(data) {
  var resp = await axios.post(`${IP}/cardCouponGoods/delete`, {
    ...data,
  });
  return resp.data;
}

